export const SITE_DETAILS = 'site_details'
export const SITE_DETAILS_BY_NO = 'site_by_no'
export const MATERIAL_DATA = 'material_data'
export const ASSOCIATE_MATERIAL = 'associate_material'
export const SAVE_MATERIAL = 'save_material'
export const MATERIAL_TYPES = 'material_types'
export const GET_REPORTEE = 'get_reportee'
export const GET_WAREHOUSE = 'get_warehouse'
export const PENDING_MATERIAL = 'pending_material'
export const VIEW_MATERIAL = 'view_material'
export const MATERIAL_APPROVAL = 'material_approval'
export const CREDITLIMIT_LEDGER = 'creditlimit_ledger'
export const TO_EMPLOYEE = 'to_employee'
export const STORE_ADDRESS = 'store_Address'
export const ERP_INVENTORY = 'erp_inventory'
export const EMP_MRF_LISTING = 'emp_mrf_listing'
export const EMP_MRF_MATERIAL = 'emp_mrf_material'
export const INCREASE_CREDIT_LIMIT = 'increase_credit_limit'
export const USER_CREDIT_LIMIT = 'user_credit_limit'
export const CAT_BY_BRAND = "CAT_BY_BRAND"
export const GET_CAT = "GET_CAT"
export const FETCH_MRF_LIST = 'FETCH_MRF_LIST'
export const MRF_TYPE_DROPDOWN = 'MRF_TYPE_DROPDOWN'
export const SHOW_MRF_VIEW = 'SHOW_MRF_VIEW'
export const SALES_RETURN_MRF = 'SALES_RETURN_MRF'
export const SEND_SALES_RETURN_TO_ERP = 'SEND_SALES_RETURN_TO_ERP'
export const SALES_RETURN_MRF_SHIPMENT = 'SALES_RETURN_MRF_SHIPMENT'
export const MRF_TYPE_LIST = 'MRF_TYPE_LIST'
export const MRF_TYPE_DROPDOWN_DATA = 'MRF_TYPE_DROPDOWN_DATA'
export const CREATE_MRF_TYPE = 'CREATE_MRF_TYPE'
export const EDIT_MRF_TYPE = 'EDIT_MRF_TYPE'
export const DELETE_MRF_TYPE = 'DELETE_MRF_TYPE'